import { AuthGuardService } from '../../../../src/app/shared/services/auth.guard.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { LayoutComponent } from '../app/modules/layout/layout.component';
import { GarageVisitComponent } from '../app/modules/garage-visit/garage-visit.component';
import { GarageSelectComponent } from '../app/modules/garage-select/garage-select.component';
import { GarageVisitConfirmationComponent } from '../app/modules/garage-visit-confirmation/garage-visit-confirmation.component';


import { P404Component } from '../../../../src/app/shared/pages/error/404.component';
import { P500Component } from '../../../../src/app/shared/pages/error/500.component';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'garage-select',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },

  {
    path: '',
    component: LayoutComponent,
    data: {
      title: 'Point-S'
    },
    children: [

      {
        path: '',
        redirectTo: 'garage-select',
        pathMatch: 'full',
      },
      {
        path: 'garage-visit/:id',
        component: GarageVisitComponent,
        pathMatch: 'full',
      },
      {
        path: 'garage-visit-confirmation/:id',
        component: GarageVisitConfirmationComponent,
        pathMatch: 'full',
      },
      {
        path: 'garage-select',
        component: GarageSelectComponent,
        pathMatch: 'full',
      }
    ]
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
